export default "__VITE_ASSET__Cnt_j_BA__"